import React, { Component } from 'react';
import { connect } from "react-redux";

import moment from "moment";
// import ApproveRejectComponent from './ApproveRejectComponent.jsx';
import { openPullout } from '../../Actions/stakeholderActions';
import { VCIcon, DivisionIcon } from '../Common/Buttons/TypeIcons.js';
import { Trans } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class BookingRequestRow extends Component {
    constructor(props) {
        super(props);

        this.viewOnCalendar = this.viewOnCalendar.bind(this);
        this.imageError = this.imageError.bind(this);
        this.goToCalendarRow = this.goToCalendarRow.bind(this);
    }

    onApproveHandler(e, props) {
    }

    onRejectHandler(e, props) {
    }

    viewOnCalendar() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');

        this.props.history.push("/bookings/info/" + this.props.booking.BOOK_ID)
        this.props.dispatch(openPullout(this.props.booking))
    }

    imageError(e) {
        e.target.src = this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square
    }

    goToCalendarRow() {
        const redirectTo = `bookings?searchTerm=${this.props.booking.vehicle.vin}`;
        this.props.history.push(redirectTo)
    }

    render() {
        const scheduledReleasedAt = moment(this.props.booking.scheduledReleasedAt).format('YYYY-MM-DDTHH:mm:ssZ');
        const scheduledReturnedAt = moment(this.props.booking.scheduledReturnedAt).format('YYYY-MM-DDTHH:mm:ssZ');

        let access = this.props.userSession?.user?.profile_access?.active_sh_vmh_access.find((item) => {return (item.SH_ID == this.props.booking.vehicle.stakeholder) && (item.VMH_ID == this.props.booking.vehicle.vmh)});
        return (
            <div className = "alert-row clickable-row" key={"booking_request_row_" + this.props.booking.vehicle.V_ID} onClick={this.goToCalendarRow}>
                <div className = "float-left">
                    {
                        this.props.booking.vehicle.Photos && this.props.booking.vehicle.Photos != '' ?
                            <img className="alert-row-image" onError={this.imageError} src={'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_' + this.props.booking.vehicle.Photos} />
                        : this.props.booking.vehicle.photoUrl && this.props.booking.vehicle.photoUrl != '' ?
                            <img className="alert-row-image" onError={this.imageError} src={this.props.booking.vehicle.photoUrl} />
                        :
                            <img className="alert-row-image" src={this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square} />
                    }
                </div>
                <div className = "float-left">
                        {
                            this.props.booking.profile ?
                            <><span className = "medium">{this.props.booking.profile.First_Name} {this.props.booking.profile.Last_Name}</span> <Trans>wants to book the</Trans> <span className = "medium">{this.props.booking.vehicle.Year} {this.props.booking.vehicle.Make} {this.props.booking.vehicle.Model} {this.props.booking.vehicle.Trim}</span></>
                            : <><span className = "medium">{this.props.booking.releasedTo}</span> <Trans>wants to book the</Trans> <span className = "medium">{this.props.booking.vehicle.displayName}</span></>
                        }
                    <div className = "clearfix"></div>
                        {this.props.booking.Start_Date ? (
                            <span className="caption">{moment(this.props.booking.Start_Date).format("MMM DD")}, {moment(this.props.booking.Release_Time, "HH:mm:ss").format("h:mmA")} – {moment(this.props.booking.End_Date).format("MMM DD")}, {moment(this.props.booking.Return_Time, "HH:mm:ss").format("h:mmA")}</span>
                        ) : (
                            <span className="caption">{moment(scheduledReleasedAt).format("MMM DD, h:mmA")} – {moment(scheduledReturnedAt).format("MMM DD, h:mmA")}</span>
                        )}
                    <div className = "clearfix mb-8"></div>
                    {/* <a className = "link medium" onClick={this.viewOnCalendar}><Trans>See On Calendar</Trans></a> */}
                </div>
                <div style={{padding:'8px 6px'}} className = "float-left clearfix">
                    {VCIcon(access?.vmh || this.props.booking.vmh, null, null, null, true)}
                    {
                        access?.stakeholder || ("stakeholder" in this.props.booking && this.props.booking.stakeholder !== null) ?
                            DivisionIcon(access?.stakeholder || this.props.booking.stakeholder, null, null, null, true)
                        :
                            null
                    }
                </div>
                {/* {
                    this.props.booking.has_authorizing || parseInt(access?.User_Role || '5') < 4 ?
                        <div className = "alert-actions">
                            <ApproveRejectComponent match={this.props.match} closeDropdown={this.props.closeDropdown} history={this.props.history} datatoggle={this.props.datatoggle} type="booking" id={this.props.booking.BOOK_ID} booking={this.props.booking} onApproveHandler={this.onApproveHandler} onRejectHandler={this.onRejectHandler} />
                        </div>
                    :
                        <span />
                } */}

                <div className = "clearfix"></div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder,
    settings: store.settings
});

export default connect(mapStateToProps)(BookingRequestRow);